import React, { useEffect, useState } from 'react'
import axiosInstance from '../../api/axiosInstance'
import { Box, Grid, } from '@mui/material'
import { useTheme } from '@mui/material/styles';
import {
  AppTasks,
  AppCurrentVisits,
  AppWebsiteVisits,
  AppWidgetSummary,
} from '../../sections/@dashboard/app';
import { Assessment, Business, Devices, Logout, People } from '@mui/icons-material';


const Home = () => {
  const theme = useTheme();
  const [users, setUsers] = useState([])
  const [devices, setDevices] = useState([])
  const [business, setBusiness] = useState([])
  const [logs, setLogs] = useState([])
  const[loading,setLoading]=useState(true);
  const getUsers = async () => {
    setLoading(true)
    try {
      const res = await axiosInstance.get("/user")
      setUsers(res.data)
    } catch (err) {
      console.log(err)
    }
  }

  const getDevices = async () => {
    try {
      const res = await axiosInstance.get("/device")
      setDevices(res.data)
    } catch (err) {
      console.log(err)
    }
  }


  const getBusiness = async () => {
    try {
      const res = await axiosInstance.get("/business")
      setBusiness(res.data)
    } catch (err) {
      console.log(err)
    }
  }

  const getLogCount = async () => {
    try {
      const res = await axiosInstance.get("/logs/count")
      setLogs(res.data)
    } catch (err) {
      console.log(err)
    }finally{
      setLoading(false);
    }
  }

  useEffect(() => {
    getUsers();
    getDevices();
    getBusiness();
    getLogCount();
  }, [])


  return (
    <Box sx={{ p: 4 }}>
      <Grid container spacing={3}>
        <Grid item xs={12} sm={6} md={3}>
          <AppWidgetSummary title="Users" total={users.length} icon={<People />} toNavigate="/users" loading={loading} />
        </Grid>

        <Grid item xs={12} sm={6} md={3}>
          <AppWidgetSummary title="Business" total={business.length} color="info" icon={<Business />} toNavigate="/business"  loading={loading}/>
        </Grid>

        <Grid item xs={12} sm={6} md={3}>
          <AppWidgetSummary title="Devices" total={devices.length} color="warning" icon={<Devices />}  loading={loading} />
        </Grid>

        <Grid item xs={12} sm={6} md={3}>
          <AppWidgetSummary title="Log Reports" total={logs} color="error" icon={<Assessment />} toNavigate="/logs" loading={loading} />
        </Grid>

        <Grid item xs={12} md={6} lg={8}>
          <AppWebsiteVisits
            title="Website Visits"
            subheader="(+43%) than last year"
            chartLabels={[
              '01/01/2003',
              '02/01/2003',
              '03/01/2003',
              '04/01/2003',
              '05/01/2003',
              '06/01/2003',
              '07/01/2003',
              '08/01/2003',
              '09/01/2003',
              '10/01/2003',
              '11/01/2003',
            ]}
            chartData={[
              {
                name: 'Team A',
                type: 'column',
                fill: 'solid',
                data: [23, 11, 22, 27, 13, 22, 37, 21, 44, 22, 30],
              },
              {
                name: 'Team B',
                type: 'area',
                fill: 'gradient',
                data: [44, 55, 41, 67, 22, 43, 21, 41, 56, 27, 43],
              },
              {
                name: 'Team C',
                type: 'line',
                fill: 'solid',
                data: [30, 25, 36, 30, 45, 35, 64, 52, 59, 36, 39],
              },
            ]}
          />
        </Grid>

        <Grid item xs={12} md={6} lg={4}>
          <AppCurrentVisits
            title="Current Visits"
            chartData={[
              { label: 'America', value: 4344 },
              { label: 'Asia', value: 5435 },
              { label: 'Europe', value: 1443 },
              { label: 'Africa', value: 4443 },
            ]}
            chartColors={[
              theme.palette.primary.main,
              theme.palette.info.main,
              theme.palette.warning.main,
              theme.palette.error.main,
            ]}
          />
        </Grid>
        <Grid item xs={12} md={12} lg={12}>
          <AppTasks
            title="Tasks"
            list={[
              { id: '1', label: 'Create FireStone Logo' },
              { id: '2', label: 'Add SCSS and JS files if required' },
              { id: '3', label: 'Stakeholder Meeting' },
              { id: '4', label: 'Scoping & Estimations' },
              { id: '5', label: 'Sprint Showcase' },
            ]}
          />
        </Grid>
      </Grid>
    </Box>
  )
}

export default Home